import React from 'react';

import { useLocation, useParams } from 'react-router';
import styled from 'styled-components';

import { usePanoramaContext } from '../../../../utils/hooks/usePanoramaContext';
import { useScrollToElement } from '../../../../utils/hooks/useScrollToElement';
import { ArticleCard } from '../../../ui/cards/Article';
import { Pagination } from '../../../ui/pagination/Pagination';

const StyleInterviewList = styled.div`
  display: grid;
  grid-row-gap: 2em;
  grid-template-columns: 1fr;
  padding-top: 2em;
  padding-bottom: 4em;
  clear: both;
  @media all and (min-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 2em;
    z-index: 50;
  }
`;

const ArticleWrapper = styled.div`
  img {
    object-fit: cover;
  }
`;

export const InterviewList: React.FC<{
  place?: string;
  pagination?: boolean;
  showAll?: boolean;
}> = ({ place, pagination }) => {
  const listRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();
  const { scrollTo } = useScrollToElement();
  const [page, setPage] = React.useState(0);
  const params = useParams<{ slug: string }>();
  const { interviews, getInterviewCountByType, getPaginatedInterviews } =
    usePanoramaContext();

  React.useEffect(() => {
    setPage(0);
  }, [location.pathname]);

  return (
    <>
      {pagination ? (
        <>
          <StyleInterviewList ref={listRef}>
            {getPaginatedInterviews({
              page,
              place,
              excludeFirst: true,
              excludeSlug: params.slug
            }).map((interview) => (
              <ArticleWrapper key={`article_${interview?.title}`}>
                <ArticleCard
                  title={interview?.card?.title}
                  image={interview?.image}
                  imageOverlay={interview?.imageOverlay}
                  description={interview?.card?.description}
                  buttonLabel={interview?.card?.buttonLabel}
                  link={interview.link}
                />
              </ArticleWrapper>
            ))}
          </StyleInterviewList>
          <Pagination
            className="pagination"
            center
            currentPage={page}
            total={getInterviewCountByType({
              place,
              excludeFirst: true
            })}
            itemsPerPage={2}
            pageRangeDisplayed={1}
            pageOnChange={({ selected }) => {
              setPage(selected);
              if (typeof scrollTo === 'function') {
                scrollTo({
                  ref: listRef,
                  distanceTop: 50,
                  behaviour: 'auto'
                });
              }
            }}
          />
        </>
      ) : (
        <StyleInterviewList>
          {interviews({
            excludeFirst: false,
            duplicate: true
          }).map((interview) => (
            <ArticleCard
              key={`article_${interview?.id}`}
              title={interview?.card?.title}
              image={interview?.image}
              imageOverlay={interview?.imageOverlay}
              description={interview?.card?.description}
              buttonLabel={interview?.card?.buttonLabel}
              link={interview.link}
            />
          ))}
        </StyleInterviewList>
      )}
    </>
  );
};
